<div class="main-container">
  @let inputClass = "flex flex-column gap-spacing-default";

  <div class="login-container">
    <div class="login-form radius-3xl">
      <div class="main-login flex flex-column gap-spacing-3xl">
        <div class="container-header gap-spacing-3xl flex flex-column">
          <div class="image-container">
            <img
              src="/assets/icons/logo-adroit-login.svg"
              alt="logo-adroit-login"
            />
          </div>

          <div class="header-typography gap-spacing-default flex flex-column">
            <div class="title-large-bold text-primary-color">
              Welcome To Adroit! 👋
            </div>
            <div class="body-medium-regular text-caption-color">
              Please sign in to your account and start the adventure
            </div>
          </div>
        </div>

        <div class="flex flex-column gap-spacing-xl">
          <form
            [formGroup]="loginForm"
            class="container-form gap-spacing-xl flex flex-column"
          >
            <div [class]="inputClass">
              <label class="input-label label-large-medium" for="email"
                >Email</label
              >
              <div class="k-input-wrapper">
                <input
                  id="email"
                  formControlName="email"
                  class="p-inputtext"
                  type="text"
                  placeholder="example@email.com"
                  (blur)="onBlurEmail()"
                  autocomplete="off"
                  pInputText
                  [class.ng-invalid]="
                    email?.touched && email?.invalid && email?.dirty
                  "
                />
              </div>
              @if (email?.touched && email?.invalid && email?.dirty) {
                <small class="input-helper-text"
                  >Please enter a valid email address.
                </small>
              }
            </div>

            <div [class]="inputClass">
              <label class="input-label label-large-medium" for="password"
                >Password</label
              >
              <div class="k-input-wrapper">
                <input
                  id="password"
                  formControlName="password"
                  class="p-inputtext"
                  [type]="passwordVisible ? 'text' : 'password'"
                  placeholder="Password"
                  maxlength="40"
                  pInputText
                  [class.ng-invalid]="
                    password?.errors?.['required'] &&
                    password?.invalid &&
                    password?.touched
                  "
                />
                <em
                  class="right-icon icon-light-color"
                  [ngClass]="passwordVisible ? 'icon-eye' : 'icon-eye-slash'"
                  (click)="togglePasswordVisibility(1)"
                  (keydown)="handleKeydown($event, 1)"
                >
                </em>
              </div>
              @if (
                password?.errors?.["required"] &&
                password?.invalid &&
                password?.touched
              ) {
                <small class="input-helper-text"
                  >Please enter a valid password</small
                >
              }
            </div>
            <p-button
              class="p-button-md login-button mt-spacing-xs"
              severity="primary"
              [disabled]="loginForm.invalid"
              (onClick)="onSubmit()"
            >
              @if ((loadingState$ | async) === false) {
                Sign In
              } @else {
                <em class="icon-circle-notch spin text-xl"></em>
              }
            </p-button>
          </form>
        </div>

        <div
          class="container-terms flex gap-spacing-default justify-content-center flex-wrap"
        >
          <span class="body-medium-regular text-caption-color"
            >By signing in I agree to ADROIT</span
          >
          <a
            class="label-large-medium text-link-color"
            href="https://www.goadroit.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service.
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="image-container"></div>
</div>
